import { initState, reducer } from "./reducers";
import thunk from "redux-thunk";
import { createStore, applyMiddleware } from "redux";

// redux store
export const store = createStore(reducer, initState, applyMiddleware(thunk));
